export default __webpack_public_path__ + "static/media/document-single.a45d1662.png";